import axios from 'axios';
import createZoom from '@/content-zoom';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const token = document.head.querySelector('meta[name="csrf-token"]') as HTMLMetaElement;

if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

const zoomElement = document.querySelector('a.zoom');

if (zoomElement instanceof HTMLElement) {
    createZoom(zoomElement, {
        size: 150,
        freezeMode: true
    });
}
